import { IComputedTheme, ThemeEnvironments } from '../types/theme';
import storeTheme from './store';
import uplayTheme from './uplay';

const mainTheme = {
  store: storeTheme,
  uplay: uplayTheme,
};
const computedTheme = (themeName: ThemeEnvironments): IComputedTheme => {
  return mainTheme[themeName];
};

export default computedTheme;
